<template>
  <v-app>
    <v-main>
      <!--   absolute containers   -->
      <app-layout-stage-highlight />
      <app-layout-build-meta-data-button />

      <!--   top header   -->
      <app-layout-main-header />

      <div
        class="page-layout"
        :class="{
          [$vuetify.display.name]: true,
          'sidebar-hidden': !authService.isLoggedIn || !userService.currentUser,
        }"
      >
        <!--  sidebar навигационная панель  -->
        <div
          v-if="authService.isLoggedIn && !!userService.currentUser"
          class="sidebar-container"
        >
          <app-layout-navigation-menu />
        </div>

        <div class="page-container">
          <div class="page-content">
            <slot />
            <!--  Место для футера  -->
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup>
import { AuthService } from '~/app-modules/auth/services/auth-service';
import { UserService } from '~/app-modules/user/services/user.service';

const authService = useIOC(AuthService);
const userService = useIOC(UserService);
</script>

<style lang="scss" scoped>
.page-layout {
  display: grid;
  height: calc(100vh - 64px);
  overflow: hidden;

  &.xs,
  &.sm {
    grid-template-columns: 224px auto;
  }

  &.md,
  &.lg,
  &.xl {
    grid-template-columns: 280px auto;
  }

  &.sidebar-hidden {
    grid-template-columns: auto;
  }
}

.sidebar-container {
  position: relative;
  height: 100%;
  border-right: 1px solid rgb(var(--v-theme-beton12));

  &.xs {
    border-right: none;
  }
}

.page-container {
  overflow: auto;
  display: flex;
  justify-content: center;
  position: relative;
  height: 100%;
}

.page-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  min-height: 100%;
  flex-grow: 1;
}
</style>
